import React from 'react';
import { benefits, bonuses } from '../data/content';
export function BonusSection() {
  return <>
      <section className="bg-brand-gray px-4 py-4 sm:px-6 sm:py-5" aria-labelledby="bonus-heading" data-id="element-15" data-mp="1ogn81qbidt6h">
        <h2 id="bonus-heading" className="mb-2.5 text-center text-[19px] font-extrabold uppercase leading-tight text-brand-navy sm:text-3xl" data-id="element-16" data-mp="22fwlwjc8sb7a">
          🎁 In Più Riceverai 5 Bonus Esclusivi
        </h2>
        <div className="space-y-1.5" data-id="element-17" data-mp="1aop6q1o1h1kv">
          {bonuses.map((bonus, index) => <article key={bonus.title} className="rounded-lg border border-brand-green/40 bg-white p-2.5 text-center shadow-sm sm:p-3" data-id="element-18" data-mp="15qnlpb71ys6r" data-mpi={index}>
              <h3 className="mb-0.5 text-[12px] font-extrabold leading-tight text-brand-navy sm:text-sm" data-id="element-19" data-mp="1epsjugepcjie">
                <span className="text-brand-red" data-id="element-20" data-mp="qzereos7gina">🎁 BONUS {index + 1} — </span>
                {bonus.title}
              </h3>
              <p className="text-[11.5px] font-medium leading-snug text-brand-ink/80 sm:text-xs" data-id="element-21" data-mp="mymglr3oq5ow">
                {bonus.description}
              </p>
            </article>)}
        </div>
      </section>
      <section className="bg-white px-4 py-4 sm:px-6 sm:py-5" aria-labelledby="change-heading" data-id="element-22" data-mp="2ep367ituefz4">
        <h2 id="change-heading" className="mb-2.5 text-center text-[19px] font-extrabold uppercase leading-tight text-brand-navy sm:text-3xl" data-id="element-23" data-mp="2jjzcnnztt5vr">
          Cosa Cambierà da Oggi
        </h2>
        <div className="space-y-1.5" data-id="element-24" data-mp="1vsbsdox2kt2g">
          {benefits.map(benefit => <article key={benefit.title} className="flex gap-2.5 rounded-lg border-l-4 border-brand-navy bg-brand-gray p-2.5 shadow-sm sm:p-3" data-id="element-25" data-mp="1vueh85mhkg5l">
              <span className="text-lg leading-none" aria-hidden="true" data-id="element-26" data-mp="25s2kxl22kxzw">
                {benefit.emoji}
              </span>
              <div data-id="element-27" data-mp="3c8wgim3aj04z">
                <h3 className="mb-0.5 text-[12px] font-extrabold leading-tight text-brand-navy sm:text-sm" data-id="element-28" data-mp="3h5en7ri6l8jy">
                  {benefit.title}
                </h3>
                <p className="text-[11.5px] font-medium leading-snug text-brand-ink/80 sm:text-xs" data-id="element-29" data-mp="1h5i1szvieen1">
                  {benefit.description}
                </p>
              </div>
            </article>)}
        </div>
      </section>
    </>;
}